import { DateTime } from "luxon";

import { ApiDataSourceSpec, apiDataSource } from "@/io/datasource/ApiDatasource.ts";
import { insulinSchema } from "@/models/diabetes/InsulinModel.ts";
import { insulinBasalRateSchema } from "@/models/InsulinBasalRate.ts";
import { closedLoopEventSchema, pumpEventSchema } from "@/models/InsulinPumpEvents.ts";
import { cz } from "@/utils/zodUtils.ts";

export class InsulinRepository {
  constructor(private readonly datasource: ApiDataSourceSpec = apiDataSource) {}

  getInsulin = (patientId: string, from: DateTime, to: DateTime) => {
    return this.datasource.get(`/practitioner/insulin/${patientId}/`, cz.forcedArray(insulinSchema), {
      params: {
        start: from.toISO(),
        end: to.toISO(),
      },
    });
  };

  getInsulinBasalRates = (patientId: string, from: DateTime, to: DateTime) => {
    return this.datasource.get(
      `/practitioner/insulin/${patientId}/basal-rates/`,
      cz.forcedArray(insulinBasalRateSchema),
      {
        params: {
          start: from.toISO(),
          end: to.toISO(),
        },
      },
    );
  };

  getInsulinPumpEvents = (patientId: string, from: DateTime, to: DateTime) => {
    return this.datasource.get(`/practitioner/pumps/${patientId}/events/`, cz.forcedArray(pumpEventSchema), {
      params: {
        start: from.toISO(),
        end: to.toISO(),
      },
    });
  };

  getClosedLoopEvents = (patientId: string, from: DateTime, to: DateTime) => {
    return this.datasource.get(`/practitioner/pumps/${patientId}/closed-loop-events/`, closedLoopEventSchema, {
      params: {
        start: from.toISO(),
        end: to.toISO(),
      },
    });
  };
}
